import { useRef, useState } from 'react'
import { useBahasa } from '../../../app/i18n'
import { kecilkan } from '../../../shared/lib/gambar'
import {
  AWALAN_TEMP, geserRef, modelPenerimaReferensi, nomorRef, peringatanRasio,
  peringatanReferensi, pilihanRasio, rasioDikirim, susunReferensi,
} from '../../../shared/lib/referensi'
import {
  AreaTeks, BarisBuat, Bendera, Body, Gambar, KV, KVBaris, Panel, Pilihan, Seg, Sub,
  Tombol,
  TombolBuat,
} from '../../../shared/ui'

const cx = (...a) => a.filter(Boolean).join(' ')

// Gaya <Tombol kecil> untuk elemen yang BUKAN tombol — sebuah <label> yang
// menyembunyikan <input type="file"> di dalamnya. Disalin, bukan dibungkus: <button>
// tidak bisa membuka pemilih berkas tanpa JavaScript tambahan.
/**
 * Pasang hasil unggahan ke satu slide — SATU perubahan, bukan dua.
 *
 * CACAT YANG DITUTUPNYA, dan ia lolos sampai ke tangan operator. `ubah()` di komponen
 * ini menutup atas `slide` MILIK RENDER ITU:
 *
 *     const ubah = (i, k, v) => setSlide(slide.map(...))
 *
 * Jadi dua panggilan berturut-turut dalam satu tick memetakan larik yang SAMA, dan yang
 * kedua menimpa yang pertama seluruhnya:
 *
 *     ubah(i, 'url', hasil)      <- dibuang
 *     ubah(i, 'biaya', null)     <- ini yang tersimpan
 *
 * Gambarnya terunggah dengan benar, rutenya menjawab 200, dan URL-nya tidak pernah
 * sampai ke layar. Gejalanya persis "kok gabisa di-upload ya?" — tidak ada galat di
 * mana pun, karena memang tidak ada yang gagal.
 *
 * `biaya` DIKOSONGKAN bersamaan: gambar unggahan tidak menagih apa pun, dan harga
 * generasi sebelumnya yang menempel membuat perkiraan tagihan di layar ini berbohong.
 *
 * MURNI supaya bisa diuji: `renderToString` tidak bisa mengunggah apa pun (XXIII-1),
 * jadi tanpa dipisahkan begini bagian ini tidak punya penjaga sama sekali.
 */
export function setelUnggah(slide, i, url, tiket = null) {
  return catatHasil(slide, i, { url, tiket, biaya: null })
}

/**
 * Catat satu hasil ke deretan slide, dan jadikan ia yang terpilih.
 *
 * TIDAK MENIMPA YANG SEBELUMNYA, dan itu seluruh maksudnya. Sampai 15 September tiap
 * "Buat ulang" membuang hasil sebelumnya dari layar — berkasnya masih di disk, tapi
 * tidak ada lagi yang bisa menunjukkan URL-nya. Jadi percobaan ketiga yang ternyata
 * paling bagus hilang begitu percobaan keempat jalan.
 *
 * Itu makin menggigit sejak ada tombol Ubah: menyunting gambar padat teks merusak
 * ketajaman teksnya sedikit tiap putaran, jadi kemampuan MUNDUR ke hasil sebelumnya
 * bukan kenyamanan — ia yang membuat kerusakan bertumpuk bisa dihindari.
 *
 * Kembar dibuang berdasarkan URL: menekan Ubah dua kali dengan instruksi yang sama bisa
 * mengembalikan berkas yang sama, dan dua kotak identik di deretan tidak menambah pilihan.
 */
export function catatHasil(slide, i, hasil) {
  return (slide ?? []).map((s, j) => {
    if (j !== i) return s
    const daftar = [...(s.hasil ?? [])]
    if (hasil?.url && !daftar.some((h) => h.url === hasil.url)) daftar.push(hasil)
    return {
      ...s,
      url: hasil?.url || '',
      tiket: hasil?.tiket ?? null,
      biaya: hasil?.biaya ?? null,
      hasil: daftar,
    }
  })
}

/**
 * Pilih satu hasil dari deretan jadi gambar slide ini — dan titik mulai Ubah berikutnya.
 *
 * URL yang tidak ada di deretan DIABAIKAN, bukan dipasang apa adanya. Memasangnya berarti
 * slide memegang gambar tanpa `tiket`, dan tombol Ubah akan menolaknya dengan 403 yang
 * tidak menyebut sebab sesungguhnya.
 */
export function pilihHasil(slide, i, url) {
  return (slide ?? []).map((s, j) => {
    if (j !== i) return s
    const h = (s.hasil ?? []).find((x) => x.url === url)
    return h ? { ...s, url: h.url, tiket: h.tiket ?? null, biaya: h.biaya ?? null } : s
  })
}

/**
 * Boleh menekan Ubah? Butuh gambar terpilih YANG PUNYA TIKET, dan instruksi yang terisi.
 *
 * Tiketnya wajib karena server menolak sumber tanpa tanda tangan — dan gambar yang
 * dimuat dari konten lama (sebelum tiket ada) memang tidak punya. Tombol yang menyala
 * lalu dijawab 403 lebih buruk daripada tombol yang mati dengan keterangan.
 */
/**
 * Apa yang BENAR-BENAR dikirim saat tombol Ubah ditekan.
 *
 * DIPISAH JADI FUNGSI MURNI supaya pertanyaan "apa saja yang ikut?" bisa dijawab uji,
 * bukan dengan membaca penangan klik di dua layar dan berharap keduanya sama.
 *
 * DUA HAL, DAN HANYA DUA: gambar yang sedang terpilih, dan teks di kotak Ubah.
 *
 * REFERENSI BRAND SENGAJA TIDAK IKUT, dan ini perbaikan atas versi pertama yang
 * menyertakannya. Model menerima referensi sebagai larik gambar yang sederajat — jadi
 * walau perintahnya berbunyi "sunting gambar pertama", referensi yang ikut tetap
 * mempengaruhi hasilnya, dan yang paling cepat rusak adalah teks di dalam gambarnya.
 * Operator melaporkannya persis: "kasih prompt baru, hasilnya tidak sesuai ekspektasi,
 * ada yang textnya berubah".
 *
 * PROMPT SLIDE (kotak teks di atas) JUGA TIDAK IKUT. Ia deskripsi gambar yang harus
 * DIBUAT; mengirimnya bersama perintah menyunting memberi model dua tugas yang
 * bertentangan, dan yang menang biasanya menggambar ulang.
 *
 * `model` ikut karena ia memilih SIAPA yang mengerjakan, bukan APA yang dikerjakan.
 */
export function bentukUbah(slide, i, instruksi, model) {
  const s = (slide ?? [])[i] || {}
  return {
    sumber: s.url || '',
    tiket: s.tiket ?? null,
    instruksi: (instruksi || '').trim(),
    model: model || null,
  }
}

export function bisaUbah(s, instruksi) {
  return Boolean(s?.url && s?.tiket && (instruksi || '').trim().length >= 3)
}

const GAYA_UNGGAH =
  'font-semibold rounded border cursor-pointer text-[11px] px-2 py-1 '
  + 'bg-surface text-ink2 border-lineStrong hover:text-ink hover:border-ink3'

const MAKS_SLIDE = 10

// Sama dengan MAKS_BYTE di `app/web/v1/referensi.py` dan CHECK di migrasi 0029.
// Diperiksa DI SINI supaya berkas kebesaran tidak pernah dikirim: proxy menolaknya lebih
// dulu dengan halaman HTML 413 yang tidak menyebut batas apa pun, dan yang membacanya
// tidak punya cara tahu sebesar apa yang boleh.
const MAKS_BYTE_REF = 6 * 1024 * 1024

// Sama dengan MAKS_BYTE_TEMP di `app/web/v1/image.py`. Diperiksa DI SINI supaya yang
// kebesaran tidak pernah dikirim: data URI membesarkan byte aslinya ~33%, jadi berkas
// 6 MB jadi badan permintaan 8 MB sebelum sempat ditolak server.
const MAKS_BYTE_TEMP = 4 * 1024 * 1024

// Sama dengan `max_length` di `ImageGenerateRequest.prompt` dan `ImageUbahRequest.
// instruksi`. Bukan batas model — pengukuran 16 September menunjukkan gemini masih
// membaca ujung prompt sampai 6000 karakter. Ini batas kewajaran: prompt gambar yang
// baik 25-60 kata, dan yang lebih panjang dari ini hampir pasti bukan prompt.
const MAKS_PROMPT = 6000
const MAKS_KATA_BRIEF = 5000

export function hitungKataBrief(teks) {
  return (teks || '').match(/\S+/gu)?.length ?? 0
}

/**
 * Baca satu berkas jadi data URI.
 *
 * `FileReader` DIBUNGKUS PROMISE karena ia berbasis peristiwa, dan penangan unggah di
 * bawah `await`-nya. Tanpa pembungkus ini, `setTemp` akan dipanggil dengan `undefined`
 * dan gambarnya tidak pernah muncul — tanpa satu pun galat.
 */
function bacaDataUri(berkas) {
  return new Promise((selesai, gagal) => {
    const fr = new FileReader()
    fr.onerror = () => gagal(new Error('Berkasnya tidak bisa dibaca.'))
    fr.onload = () => selesai(String(fr.result || ''))
    fr.readAsDataURL(berkas)
  })
}

/**
 * PANEL GAMBAR — daftar SLIDE, bukan satu prompt dan satu gambar.
 *
 * Bentuk lamanya mengasumsikan satu gambar: satu prompt, satu tombol, satu pratinjau.
 * Model itu patah begitu collase masuk — operator bertanya "bagaimana kalau saya mau
 * mengedit gambar di collasenya", dan jawabannya di bentuk lama tidak ada. Prompt-nya
 * cuma satu, jadi membuat ulang satu slide berarti membuat ulang semuanya.
 *
 * COLLASE BUKAN SATU KONTEN DENGAN BANYAK GAMBAR — ia banyak slide, masing-masing punya
 * idenya sendiri. Karena itu tiap slide punya promptnya sendiri dan tombol buat-ulangnya
 * sendiri, dan konten tunggal jadi kasus khusus yang sederhana: satu slide.
 *
 * Yang TETAP bersama di atas: model dan referensi. Keduanya berlaku untuk seluruh slide —
 * collase dengan gaya berbeda-beda per slide bukan collase, ia kumpulan gambar.
 */
/**
 * Label satu pilihan model di dalam combo box.
 *
 * SATU BARIS HARUS MEMBAWA APA YANG DULU DIBAWA KARTU. `<select>` cuma punya teks —
 * tidak ada chip, tidak ada baris kedua — jadi tingkat dan peringatan tarif ikut masuk ke
 * teksnya. Yang TIDAK ikut `model_id`: ia panjang, ia sama-sama diawali nama penyedia,
 * dan sepuluh baris yang semuanya berawalan sama justru lebih sulit dibaca. Ia
 * ditampilkan di bawah kotaknya, untuk yang SEDANG dipilih saja.
 *
 * Fungsi murni supaya bisa diuji: menyusun label yang salah tidak menghasilkan galat
 * apa pun, cuma layar yang menyesatkan soal harga.
 */
export function labelModel(m, t) {
  const bagian = [m.name || m.model_id]
  if (m.tier) bagian.push(m.tier)
  // Model tanpa tarif tetap menagih tapi tidak pernah menambah angka pagu. Itu harus
  // terbaca SAAT MEMILIH, bukan sesudah tagihannya datang — jadi ia masuk ke labelnya,
  // bukan cuma ke keterangan di bawah.
  if (m.tarif_diketahui === false) bagian.push(t('bk.modelTanpaTarif'))
  return bagian.join(' · ')
}

/**
 * PEMILIH MODEL — combo box, bukan kisi kartu dan bukan bilah mendatar.
 *
 * Dua bentuk sebelumnya salah dengan cara yang berbeda. `<Seg>` memanjang ke samping
 * sampai mendorong kolomnya. Kisi kartu tidak memanjang, tapi menghabiskan empat baris
 * layar untuk kendali yang jarang disentuh — di panel yang sudah berisi prompt,
 * referensi, dan daftar slide.
 *
 * Dan docstring `<Seg>` di `shared/ui` sudah menuliskan jawabannya sejak awal: *"Kalau
 * daftarnya bisa panjang (katalog model yang tumbuh), pakai `<Pilihan>`."*
 *
 * Tingginya TETAP, berapa pun jumlah modelnya. Di ponsel ia jadi pemilih bawaan sistem,
 * yang tidak mungkin ditandingi apa pun yang dibuat sendiri.
 *
 * `model_id` DITAMPILKAN DI BAWAHNYA untuk yang sedang dipilih. Ia yang muncul di galat
 * OpenRouter dan di layar Pemakaian, jadi orang yang mencocokkan tagihan dengan pilihan
 * butuh melihatnya — dan menaruhnya di tiap baris daftar hanya membuat sepuluh baris
 * berawalan sama.
 */
export function PilihModel({ daftar, nilai, set, t }) {
  const terpilih = daftar.find((m) => m.model_id === nilai)

  return (
    <span className="flex flex-col gap-1 items-start min-w-0">
      <Pilihan
        aria-label={t('bk.model')}
        value={nilai}
        onChange={(e) => set(e.target.value)}
        className="max-w-full"
      >
        <option value="">{t('bk.modelBawaan')}</option>
        {daftar.map((m) => (
          <option key={m.model_id} value={m.model_id}>{labelModel(m, t)}</option>
        ))}
      </Pilihan>

      {/* Bawaan TIDAK punya `model_id` — yang dipakai ditentukan saat itu juga, urut
          pilihan admin, dan menyebut satu nama di sini akan berbohong tentang mana yang
          benar-benar dipakai. */}
      <span className="font-mono text-[10.5px] text-ink3 truncate max-w-full"
            title={terpilih?.model_id || t('bk.modelBawaanCatatan')}>
        {terpilih?.model_id || t('bk.modelBawaanCatatan')}
      </span>
    </span>
  )
}

/**
 * Satu bagian di panel Gambar: judul kecil, isinya penuh di bawahnya.
 *
 * TANPA NOMOR, dan itu koreksi. Bentuk sebelumnya memberi tiap bagian lencana bernomor;
 * operator menanyakannya langsung — *"Ada angka angka di samping bahan gambar, brief untuk
 * ai. Itu untuk apa?"* — dan pertanyaan itu jawabannya sendiri. Nomor yang harus dijelaskan
 * bukan nomor yang membantu; judulnya sudah cukup menyatakan urutan karena ia dibaca dari
 * atas ke bawah.
 *
 * ISINYA PENUH, TIDAK MENJOROK. Bentuk sebelumnya menjorokkan isi 26px DAN membungkusnya
 * lagi dalam `KV` berkolom label 150px — dua kolom label bertumpuk, menyisakan lorong
 * kosong selebar sepertiga panel. Yang punya pasangan label/nilai sungguhan (Model, Rasio)
 * tetap memakai `KV`; yang isinya satu hal tidak perlu label kedua yang mengulang judulnya.
 */
function Bagian({ judul, catatan, children }) {
  return (
    <section className="flex flex-col gap-2 border-t border-line pt-3 first:border-0 first:pt-0">
      <h3 className="m-0 text-[11px] font-semibold uppercase tracking-[.08em] text-ink3">
        {judul}
      </h3>
      {catatan && <Sub className="mt-0">{catatan}</Sub>}
      {children}
    </section>
  )
}

export default function PanelGambar({
  slide, setSlide, daftarModel, model, setModel, video = false,
  referensi, refDipakai, setRefDipakai,
  // KELOLA REFERENSI TERSIMPAN — hanya ada kalau layarnya memberikannya.
  //
  // Bentuk sebelumnya memakai bendera `bolehKelolaRef` SEKALIGUS tetap menerima
  // hooknya, jadi kemampuannya masih ada dan cuma tidak terlihat. Bendera dan
  // kemampuan yang bisa menyimpang adalah cara paling pasti membuat tombolnya kembali
  // muncul tanpa ada yang bermaksud begitu.
  //
  // Sekarang satu aturan, sama dengan `unggahSlide` dan `ubahGambar` di bawah: layar
  // yang tidak memberikan hooknya tidak menampilkan tombolnya. Sejak 16 September
  // referensi tersimpan dikelola Smova Admin, jadi kedua layar tenant tidak
  // memberikannya sama sekali.
  unggah, pensiun,
  // GAMBAR TEMPORARY milik pemakai layar: peta `temp:<n>` -> data URI. Tidak pernah
  // tersimpan, hilang saat halaman ditutup. Opsional — layar yang tidak memberikannya
  // menyembunyikan tombolnya, bukan menampilkan tombol yang pasti gagal.
  temp, setTemp,

  // Menandai referensi sebagai bahan brand. Opsional: layar yang tidak
  // memberikannya menyembunyikan tombolnya, bukan menampilkan tombol mati.
  jenisRef,
  buatGambar, sedangBuat, galat, buatPrompt, sedangPrompt, bisaPrompt,
  // Template prompt yang bisa dipilih, dan yang sedang dipilih (ADR-076). Menentukan
  // JENIS gambarnya: foto tanpa tulisan, atau poster berheadline dan CTA. Opsional —
  // layar yang tidak memberikannya memakai template bawaan tenant.
  // BRIEF untuk penulis prompt (ADR-077). Boleh kosong, dan ia yang paling menentukan —
  // tidak ada lagi mode, template, atau pemeriksa yang membatasi hasilnya.
  // JENIS KONTEN — foto atau video. PINDAH KE SINI dari tab "Isi konten" (ADR-077):
  // ia menentukan apa yang dibuat di panel INI, bukan apa yang ditulis di caption.
  // Opsional; layar yang tidak memberikannya tidak menampilkan pemilihnya.
  jenis, setJenis,
  brief, setBrief,
  // `{sistem, pengguna, gambar}` dari panggilan terakhir — apa yang BENAR-BENAR dikirim.
  dikirimPrompt,
  // Bahan dipilih tapi model teksnya tidak bisa melihat gambar.
  bahanDiabaikan,
  // UNGGAH GAMBAR JADI, berbeda dari `unggah` di atas yang mengurus REFERENSI.
  // Referensi adalah bahan yang dikirim KE model; ini gambar akhirnya sendiri, dan
  // sampai 14 September satu-satunya cara mendapatkannya adalah menyuruh model membuatnya.
  // Opsional: layar yang tidak memberikannya tidak menampilkan tombolnya sama sekali.
  unggahSlide,
  // MENGUBAH gambar yang sudah ada, berbeda dari `buatGambar` yang membuat dari nol.
  // Opsional: layar yang tidak memberikannya menyembunyikan seluruh baris Ubah, bukan
  // menampilkan tombol yang pasti gagal.
  ubahGambar,
}) {
  const { t, locale } = useBahasa()
  const kataBrief = hitungKataBrief(brief)
  const briefTerlaluPanjang = kataBrief > MAKS_KATA_BRIEF
  // Diturunkan, bukan diterima: tidak ada bendera yang bisa menyimpang dari
  // kemampuan yang sebenarnya ada.
  const bolehKelolaRef = Boolean(unggah && pensiun)
  const berkasRef = useRef(null)
  const [galatUnggah, setGalatUnggah] = useState('')
  // Slide mana yang sedang diunggah, dan galatnya. Satu pada satu waktu: dua unggahan
  // berbarengan ke slide yang sama membuat yang selesai belakangan menimpa yang duluan,
  // dan yang menekannya melihat gambar yang bukan pilihannya.
  const [slideDiunggah, setSlideDiunggah] = useState(null)
  const [galatSlide, setGalatSlide] = useState('')
  // Apa yang terjadi pada berkas orang. Ditampilkan, tidak disembunyikan.
  const [kabarUnggah, setKabarUnggah] = useState('')
  // Instruksi perubahan per slide, dan slide mana yang sedang diubah. Satu pada satu
  // waktu: dua suntingan berbarengan pada slide yang sama membuat yang selesai
  // belakangan menimpa yang duluan, dan yang menekannya melihat hasil yang bukan
  // pilihannya — cacat yang sama persis dengan unggahan slide di atas.
  const [instruksi, setInstruksi] = useState({})
  const [sedangUbah, setSedangUbah] = useState(null)
  // RASIO PILIHAN ORANG untuk model yang sedang dipilih; '' = bawaan model. Tidak direset
  // saat model berganti — `rasioDikirim` yang menyaring pilihan basi, jadi tidak ada
  // efek yang bisa tertinggal satu render di belakang.
  const [rasio, setRasio] = useState('')

  const ubah = (i, k, v) => setSlide(slide.map((s, j) => (j === i ? { ...s, [k]: v } : s)))
  const geser = (i, arah) => {
    const j = i + arah
    if (j < 0 || j >= slide.length) return
    const b = [...slide]
    ;[b[i], b[j]] = [b[j], b[i]]
    setSlide(b)
  }

  const jadi = slide.filter((s) => s.url).length
  const collase = slide.length > 1
  // Keputusannya di `shared/lib/referensi.js` — fungsi murni, supaya bisa diuji
  // tanpa mengklik apa pun. Lihat catatan di sana soal kenapa 'Bawaan' berbeda.
  const adaReferensi = refDipakai.length > 0
  const peringatan = peringatanReferensi(adaReferensi, model, daftarModel)
  // Daftar rasio MENEMPEL DI MODEL (ADR-073) — dari `/dashboard/model`, bukan dari kode.
  const pilihan = video ? null : pilihanRasio(daftarModel, model)
  const rasioKirim = rasioDikirim(pilihan, rasio, adaReferensi)
  const rasioTerkunci = Boolean(pilihan && adaReferensi && pilihan.abaikanDenganReferensi)

  return (
    <Panel
      judul={t(video ? 'bk.grupVideo' : 'bk.grupGambar')}
      catatan={collase ? t('bk.collaseAktif', { n: slide.length }) : null}
    >
      <Body className="flex flex-col gap-4">
          {jenis && setJenis && (
            <KV>
              <KVBaris label={t('bk.jenis')}>
                <Seg
                  nilai={jenis}
                  set={setJenis}
                  daftar={[
                    { id: 'photo', label: t('bk.foto') },
                    { id: 'video', label: t('bk.video') },
                  ]}
                />
              </KVBaris>
            </KV>
          )}

        {/* ── 1 · BAHAN ──────────────────────────────────────────────────
            Paling atas karena ia yang PERTAMA dipilih orangnya, dan karena brief di
            bawahnya sering menyebut bahan yang mana ("pakai template ini sebagai latar").
            Urutan lama menaruh model dan rasio lebih dulu — dua hal yang baru berlaku
            jauh di akhir, saat gambarnya dibuat. */}
        {/* SELURUH BAGIAN disembunyikan untuk video, bukan cuma isinya.
            Penjaga `!video` dulu ada DI DALAM, jadi judul "Bahan gambar" tetap tampil
            dengan ruang kosong di bawahnya — judul yang tidak memayungi apa pun terbaca
            sebagai bagian yang gagal memuat. Ditangkap uji render, bukan oleh mata. */}
        {!video && (
        <Bagian judul={t('bk.bagianBahan')}>
          {/* REFERENSI HANYA UNTUK GAMBAR. Yang menerima gambar masukan adalah sebagian
              model GAMBAR (`terima_referensi` di katalog); tidak satu pun model video di
              katalog menerimanya. Menampilkan pemilihnya di jalur video berarti
              menawarkan sesuatu yang pasti diabaikan tanpa satu pun pesan. */}
          {!video && (
          <>
            <div className="flex flex-wrap gap-2.5">
              {susunReferensi(referensi.data ?? []).map((r) => {
                const nomor = nomorRef(refDipakai, r.id)
                const dipakai = nomor > 0
                const brand = r.jenis === 'brand'
                return (
                  <figure key={r.id} className="m-0 flex flex-col gap-1 w-[68px]">
                    <div className="relative">
                      <button
                        type="button"
                        aria-pressed={dipakai}
                        title={r.nama}
                        onClick={() => setRefDipakai(
                          dipakai ? refDipakai.filter((x) => x !== r.id) : [...refDipakai, r.id],
                        )}
                        className={cx(
                          'w-[68px] h-[68px] rounded-[5px] border overflow-hidden cursor-pointer p-0 bg-surface2',
                          dipakai ? 'border-accent ring-1 ring-accent' : 'border-line hover:border-ink3',
                        )}
                      >
                        <Gambar src={r.url} className="w-full h-full object-cover"
                                teksHilang={t('bk.gambarHilang')} />
                      </button>
                      {/* NOMORNYA TERLIHAT. Urutan referensi menentukan arti bagi model
                          (lihat `nomorRef`), dan sampai 15 September satu-satunya tanda
                          terpilih adalah warna garis tepi — jadi tidak ada cara melihat
                          mana gambar 1 dan mana gambar 2 sebelum menekan Buat. */}
                      {dipakai && (
                        <span
                          aria-label={t('bk.refUrutanKe', { n: nomor })}
                          className="absolute -top-1 -left-1 min-w-[16px] h-[16px] px-1 rounded-full
                                     bg-accent text-surface text-[10px] font-bold leading-[16px]
                                     text-center pointer-events-none"
                        >
                          {nomor}
                        </span>
                      )}
                      {(brand || r.jenis === 'orang') && (
                        <span
                          title={brand ? t('bk.refBrandKet') : t('tk.refJenisOrangKet')}
                          className="absolute -top-1 -right-1 h-[16px] px-1 rounded-full bg-surface2
                                     border border-lineStrong text-[9px] font-semibold leading-[14px]
                                     text-ink2 pointer-events-none"
                        >
                          {brand ? t('bk.refBrand') : t('tk.refOrang')}
                        </span>
                      )}
                    </div>
                    <figcaption className="flex items-center justify-between gap-1">
                      {bolehKelolaRef && (
                      <button
                        type="button"
                        aria-pressed={brand}
                        title={brand ? t('bk.refJadikanSekali') : t('bk.refJadikanBrand')}
                        disabled={jenisRef?.isPending}
                        onClick={() => jenisRef?.mutate({
                          id: r.id, jenis: brand ? 'sekali_pakai' : 'brand',
                        })}
                        className={cx(
                          'text-[10px] leading-none bg-transparent border-0 cursor-pointer p-0 shrink-0',
                          brand ? 'text-accent' : 'text-ink3 hover:text-ink2',
                        )}
                      >
                        ★
                      </button>
                      )}
                      <span className="text-[10px] text-ink3 truncate" title={r.nama}>{r.nama}</span>
                      {bolehKelolaRef && (
                      <button
                        type="button"
                        title={t('bk.refBuang')}
                        disabled={pensiun?.isPending}
                        onClick={() => {
                          setRefDipakai(refDipakai.filter((x) => x !== r.id))
                          pensiun.mutate(r.id)
                        }}
                        className="text-[11px] leading-none text-ink3 hover:text-bad bg-transparent
                                   border-0 cursor-pointer p-0 shrink-0"
                      >
                        ×
                      </button>
                      )}
                    </figcaption>
                  </figure>
                )
              })}

              {bolehKelolaRef && (
              <button
                type="button"
                disabled={unggah?.isPending}
                onClick={() => berkasRef.current?.click()}
                className="w-[68px] h-[68px] rounded-[5px] border border-dashed border-lineStrong
                           bg-surface2 text-[10px] font-semibold text-ink2 cursor-pointer grid
                           place-items-center px-1.5 text-center hover:border-accent hover:text-accent
                           disabled:opacity-45 disabled:cursor-not-allowed"
              >
                {unggah?.isPending ? t('bk.refMengunggah') : t('bk.refTambah')}
              </button>
              )}
              <input
                ref={berkasRef}
                type="file"
                accept="image/png,image/jpeg,image/webp"
                hidden
                onChange={async (e) => {
                  const asli = e.target.files?.[0]
                  // Dikosongkan supaya memilih berkas YANG SAMA dua kali tetap memicu
                  // onChange — kalau tidak, unggah ulang sesudah gagal terlihat mati.
                  e.target.value = ''
                  if (!asli) return
                  setGalatUnggah('')
                  setKabarUnggah('')

                  // DIKECILKAN DULU. Referensi ikut dikirim ke model sebagai data URI
                  // pada SETIAP pembuatan gambar — yang besar ditagih berulang, dan
                  // model mengecilkannya sendiri di dalam. Yang sudah kecil tidak
                  // disentuh sama sekali.
                  const { berkas, diubah, sebelum, sesudah } = await kecilkan(asli)

                  if (berkas.size > MAKS_BYTE_REF) {
                    setGalatUnggah(t('bk.refTerlaluBesar', {
                      ukuran: (berkas.size / 1024 / 1024).toFixed(1),
                      maks: MAKS_BYTE_REF / 1024 / 1024,
                    }))
                    return
                  }
                  if (diubah) {
                    setKabarUnggah(t('bk.refDikecilkan', {
                      lebar: sebelum.lebar, tinggi: sebelum.tinggi,
                      lebarBaru: sesudah.lebar, tinggiBaru: sesudah.tinggi,
                      dari: (sebelum.bytes / 1024 / 1024).toFixed(1),
                      jadi: (sesudah.bytes / 1024).toFixed(0),
                    }))
                  }
                  unggah.mutate(berkas)
                }}
              />
            </div>

            {/* ── GAMBAR SAYA (TEMPORARY) ─────────────────────────────────
                Referensi tersimpan dikelola Tenant Admin; ini jalur marketing.
                Gambarnya dikirim sebagai data URI dan TIDAK PERNAH tersimpan —
                tidak ada baris yang menumpuk, tidak ada yang perlu dipensiunkan,
                dan hak akses kolam brand tetap utuh. Hilang saat halaman ditutup,
                dan itu dikatakan, bukan dibiarkan jadi kejutan. */}
            {setTemp && (
              <div className="mt-2 flex flex-col gap-1.5">
                <Sub>{t('bk.tempJudul')}</Sub>
                <div className="flex flex-wrap gap-2.5">
                  {Object.entries(temp ?? {}).map(([kunci, data]) => {
                    const nomor = nomorRef(refDipakai, kunci)
                    const dipakai = nomor > 0
                    return (
                      <figure key={kunci} className="m-0 flex flex-col gap-1 w-[68px]">
                        <div className="relative">
                          <button
                            type="button"
                            aria-pressed={dipakai}
                            onClick={() => setRefDipakai(
                              dipakai ? refDipakai.filter((x) => x !== kunci)
                                      : [...refDipakai, kunci],
                            )}
                            className={cx(
                              'w-[68px] h-[68px] rounded-[5px] border overflow-hidden',
                              'cursor-pointer p-0 bg-surface2',
                              dipakai ? 'border-accent ring-1 ring-accent'
                                      : 'border-line hover:border-ink3',
                            )}
                          >
                            <Gambar src={data} className="w-full h-full object-cover"
                                    teksHilang={t('bk.gambarHilang')} />
                          </button>
                          {dipakai && (
                            <span className="absolute -top-1 -left-1 min-w-[16px] h-[16px]
                                             px-1 rounded-full bg-accent text-surface
                                             text-[10px] font-bold leading-[16px]
                                             text-center pointer-events-none">
                              {nomor}
                            </span>
                          )}
                        </div>
                        <figcaption className="flex items-center justify-between gap-1">
                          <span className="text-[10px] text-ink3">{t('bk.tempLabel')}</span>
                          <button
                            type="button"
                            title={t('bk.tempBuang')}
                            onClick={() => {
                              setRefDipakai(refDipakai.filter((x) => x !== kunci))
                              setTemp((x) => {
                                const y = { ...x }
                                delete y[kunci]
                                return y
                              })
                            }}
                            className="text-[11px] leading-none text-ink3 hover:text-bad
                                       bg-transparent border-0 cursor-pointer p-0 shrink-0"
                          >
                            ×
                          </button>
                        </figcaption>
                      </figure>
                    )
                  })}
                  <label className="inline-flex">
                    <span className={cx(GAYA_UNGGAH,
                      'w-[68px] h-[68px] grid place-items-center text-center px-1')}>
                      {t('bk.tempTambah')}
                    </span>
                    <input
                      type="file" accept="image/png,image/jpeg,image/webp" className="hidden"
                      onChange={async (e) => {
                        const asli = e.target.files?.[0]
                        e.target.value = ''
                        if (!asli) return
                        setGalatUnggah('')
                        try {
                          const { berkas } = await kecilkan(asli)
                          if (berkas.size > MAKS_BYTE_TEMP) {
                            setGalatUnggah(t('bk.tempTerlaluBesar', {
                              ukuran: (berkas.size / 1024 / 1024).toFixed(1),
                              maks: MAKS_BYTE_TEMP / 1024 / 1024,
                            }))
                            return
                          }
                          const data = await bacaDataUri(berkas)
                          const kunci = `${AWALAN_TEMP}${Date.now()}`
                          setTemp((x) => ({ ...(x ?? {}), [kunci]: data }))
                          setRefDipakai((x) => [...x, kunci])
                        } catch (err) {
                          setGalatUnggah(err?.message || String(err))
                        }
                      }}
                    />
                  </label>
                </div>
                <Sub>{t('bk.tempKet')}</Sub>
              </div>
            )}

            {/* URUTAN YANG BISA DIUBAH, bukan cuma dilihat.
                Tanpa ini satu-satunya cara memindahkan gambar 2 jadi gambar 1 adalah
                melepas SEMUANYA lalu memilih ulang berurutan — bisa, tapi tidak ada
                yang menebaknya, dan salah urut tidak menghasilkan galat apa pun. */}
            {refDipakai.length > 1 && (
              <div className="mt-2 flex flex-col gap-1">
                <Sub>{t('bk.refUrutan')}</Sub>
                <ol className="m-0 p-0 list-none flex flex-col gap-1">
                  {refDipakai.map((id, i) => {
                    const r = (referensi.data ?? []).find((x) => x.id === id)
                    return (
                      <li key={id} className="flex items-center gap-1.5 text-[11px]">
                        <span className="min-w-[16px] h-[16px] rounded-full bg-accent text-surface
                                         font-bold leading-[16px] text-center shrink-0">
                          {i + 1}
                        </span>
                        <span className="truncate text-ink2" title={r?.nama}>
                          {r?.nama ?? t('bk.refHilang')}
                        </span>
                        <span className="ml-auto flex items-center gap-0.5 shrink-0">
                          <Tombol kecil jenis="kedua" type="button" disabled={i === 0}
                                  onClick={() => setRefDipakai(geserRef(refDipakai, id, -1))}
                                  aria-label={t('bk.refNaikkan')}>↑</Tombol>
                          <Tombol kecil jenis="kedua" type="button"
                                  disabled={i === refDipakai.length - 1}
                                  onClick={() => setRefDipakai(geserRef(refDipakai, id, 1))}
                                  aria-label={t('bk.refTurunkan')}>↓</Tombol>
                        </span>
                      </li>
                    )
                  })}
                </ol>
              </div>
            )}
            <Sub>{t('bk.refCatatan')}</Sub>
            {/* `unggah` boleh TIDAK ADA — layar tenant tidak lagi mengelola referensi
                tersimpan. `galatUnggah` tetap dipakai jalur temporary, jadi spanduknya
                tidak boleh ikut hilang bersama hooknya. */}
            {(galatUnggah || unggah?.isError) && (
              <Bendera nada="bad" role="alert" className="mt-2">
                {galatUnggah || unggah?.error?.message}
              </Bendera>
            )}
            {kabarUnggah && !galatUnggah && (
              <Bendera nada="info" role="status" className="mt-2">{kabarUnggah}</Bendera>
            )}
            {/* MODEL YANG MENGABAIKAN RASIO DI JALUR REFERENSI — terukur. Dikatakan SEBELUM
                menekan Buat, bukan sesudah referensi 4:5 kembali sebagai persegi. */}
            {peringatanRasio(daftarModel, model, adaReferensi) && (
              <Bendera nada="warn" className="mt-2">{t('bk.rasioDiabaikan')}</Bendera>
            )}
            {/* Prompt hasil mesin yang masih melanggar aturan sesudah satu kali
                perbaikan. Ditulis apa adanya — tiap pesannya sudah menyebut apa yang
                salah DAN apa gantinya, jadi ia bisa ditindaklanjuti orangnya. */}
            {/* APA YANG DIKIRIM KE AI — dilipat, jadi ia ada tanpa memenuhi layar.
                Diminta operator: tanpa ini satu-satunya cara mengetahui aturan apa yang
                benar-benar berlaku adalah membaca kode atau log server, dan yang menyetel
                aturannya di layar tidak punya keduanya. */}
            {dikirimPrompt?.sistem && (
              <details className="mt-2 text-[11px]">
                <summary className="cursor-pointer text-ink3 hover:text-ink2">
                  {t('bk.dikirimJudul', { gambar: dikirimPrompt.gambar ?? 0 })}
                </summary>
                <pre className="mt-1.5 max-h-[320px] overflow-auto whitespace-pre-wrap
                                rounded border border-line bg-surface2 p-2 text-[10.5px]
                                leading-[1.45] text-ink2">
{dikirimPrompt.sistem}
{'\n--- pesan pengguna ---\n'}
{dikirimPrompt.pengguna}
                </pre>
              </details>
            )}
            {peringatan && (
              <Bendera nada="warn" className="mt-2">
                {peringatan === 'bawaan'
                  ? t('bk.refBawaanTakBisa')
                  : t('bk.refModelSalah', {
                    model: modelPenerimaReferensi(daftarModel).join(', ') || '—',
                  })}
              </Bendera>
            )}
          </>
          )}
        </Bagian>
        )}

        {/* ── 2 · BRIEF ──────────────────────────────────────────────────── */}
        <Bagian judul={t('bk.bagianBrief')}>
          {/* BRIEF — SEKALI per konten, di atas daftar slide (ADR-077).
              Ia yang paling menentukan hasilnya, dan boleh kosong. Tidak ada pemilih mode
              maupun template: keduanya dibongkar karena satu kalimat brief mengatakan hal
              yang sama dengan lebih jujur. */}
          <AreaTeks
            baris={4}
            value={brief ?? ''}
            maxLength={100000}
            aria-invalid={briefTerlaluPanjang}
            placeholder={t('bk.briefContoh')}
            onChange={(e) => setBrief?.(e.target.value)}
          />
          <Sub className="mt-0">{t('bk.briefKet')}</Sub>
          <Sub className={cx('mt-0', briefTerlaluPanjang && 'text-bad')}>
            {t('bk.briefHitung', {
              jumlah: kataBrief.toLocaleString(locale),
              maks: MAKS_KATA_BRIEF.toLocaleString(locale),
            })}
            {briefTerlaluPanjang ? ` · ${t('bk.briefLebih')}` : ''}
          </Sub>

          {/* SATU TOMBOL untuk SEMUA slide. Slide harus maju berurutan, dan satu tombol
              per slide menghasilkan slide yang tidak berhubungan satu sama lain. */}
          <BarisBuat>
            <TombolBuat
              disabled={sedangPrompt || briefTerlaluPanjang || !(brief?.trim() || bisaPrompt)}
              onClick={() => buatPrompt()}
            >
              {sedangPrompt ? t('bk.promptSedang')
                            : t(slide.length > 1 ? 'bk.promptSemuaSlide'
                                                 : 'bk.promptDariCaption')}
            </TombolBuat>
          </BarisBuat>
          {bahanDiabaikan && (
            <Bendera nada="warn" className="mt-2">{t('bk.bahanDiabaikan')}</Bendera>
          )}

        </Bagian>

        {/* ── 3 · MODEL & RASIO ──────────────────────────────────────────
            Sesudah brief, bukan sebelum: keduanya BERLAKU UNTUK SEMUA SLIDE dan tidak
            memengaruhi promptnya sama sekali. Menaruhnya paling atas membuat orang
            memilih model sebelum tahu gambar apa yang akan dibuat. */}
        <Bagian judul={t('bk.bagianModel')} catatan={t('bk.bagianModelKet')}>
          <KV>
          {/* TINGKAT 3 (ADR-054) — hanya dari `tenant_ai_models`. Berlaku untuk SEMUA
              slide: collase yang tiap slidenya model berbeda tidak terlihat satu kesatuan. */}
          {/* "MODEL", BUKAN "MODEL GAMBAR". Barisnya sekarang menampilkan model video
              juga — mana yang muncul ditentukan jenis kontennya, bukan oleh nama
              barisnya. Label yang menyebut "gambar" di atas daftar berisi Veo dan
              Seedance akan terbaca sebagai layar yang salah. */}
          <KVBaris label={t('bk.model')}>
            {daftarModel.length === 0 ? (
              <span className="text-[12px] text-warn">{t('bk.modelKosong')}</span>
            ) : (
              <PilihModel daftar={daftarModel} nilai={model} set={setModel} t={t} />
            )}
            <Sub>{t('bk.modelCatatan')}</Sub>
          </KVBaris>

          {/* RASIO — hanya kalau katalog tahu daftar model YANG DIPILIH. "Bawaan" tidak
              diberi pemilih: tiap model di rantai punya daftar sendiri, dan satu pilihan
              tidak mungkin sah untuk semuanya. */}
          {pilihan && (
            <KVBaris label={t('bk.rasio')}>
              <Pilihan
                aria-label={t('bk.rasio')}
                value={rasioKirim ?? ''}
                disabled={rasioTerkunci}
                onChange={(e) => setRasio(e.target.value)}
                className="max-w-full"
              >
                {/* Arti "kosong" BERBEDA dengan dan tanpa referensi, dan labelnya harus
                    mengatakannya: tanpa referensi bawaan model yang dipakai; dengan
                    referensi tidak ada rasio yang dikirim sama sekali, supaya suntingan
                    dan gambar berreferensi tidak dipaksa berubah bentuk. */}
                <option value="">
                  {adaReferensi
                    ? t('bk.rasioIkutModel')
                    : t('bk.rasioBawaan', { rasio: pilihan.bawaan ?? t('bk.rasioPenyedia') })}
                </option>
                {pilihan.daftar.map((r) => <option key={r} value={r}>{r}</option>)}
              </Pilihan>
              <Sub>{t('bk.rasioCatatan')}</Sub>
            </KVBaris>
          )}

          </KV>
        </Bagian>

        {/* ── 4 · SLIDE ──────────────────────────────────────────────────── */}
        <Bagian judul={t('bk.bagianSlide')}>
        <div className="flex flex-col gap-3">
          {slide.map((s, i) => (
            <div
              key={i}
              className="grid grid-cols-[132px_minmax(0,1fr)] gap-3 items-start
                         bg-surface2 border border-line rounded-md p-3"
            >
              <div className="flex flex-col gap-1.5">
                <div className="w-[132px] h-[132px] rounded border border-line bg-surface
                                grid place-items-center overflow-hidden">
                  {/* `<video>`, BUKAN `<img>`. `<img src="...mp4">` gagal diam-diam:
                      kotaknya kosong, tanpa galat di layar maupun di log — dan yang
                      melihatnya menyimpulkan videonya tidak jadi, padahal jadi dan
                      sudah ditagih. */}
                  {!s.url ? (
                    <span className="text-[10.5px] text-ink3 px-2 text-center">
                      {t('bk.slideKosong')}
                    </span>
                  ) : video ? (
                    <video src={s.url} controls className="w-full h-full object-cover" />
                  ) : (
                    <Gambar src={s.url} className="w-full h-full object-cover"
                            teksHilang={t('bk.gambarHilang')} />
                  )}
                </div>
                <div className="flex items-center justify-between gap-1">
                  <b className="text-[11px] font-mono text-accent">
                    {i + 1}{i === 0 && collase ? ` · ${t('bk.slidePertama')}` : ''}
                  </b>
                  {/* DIRENDER BERSYARAT, bukan disembunyikan dengan `hidden`.
                      Yang disembunyikan tetap ada di halaman: pembaca layar tetap
                      menyebutnya, dan uji render tetap melihatnya — jadi suntikan yang
                      salah menampilkannya lolos tanpa satu pun tanda. */}
                  {!video && (
                  <span className="flex gap-1">
                    <Tombol kecil jenis="sekunder" disabled={i === 0}
                            onClick={() => geser(i, -1)} aria-label={t('ta.naik')}>‹</Tombol>
                    <Tombol kecil jenis="sekunder" disabled={i === slide.length - 1}
                            onClick={() => geser(i, 1)} aria-label={t('ta.turun')}>›</Tombol>
                    <Tombol kecil jenis="sekunder" disabled={slide.length === 1}
                            onClick={() => setSlide(slide.filter((_, j) => j !== i))}>×</Tombol>
                  </span>
                  )}
                </div>
              </div>

              <div className="flex flex-col gap-1.5 min-w-0">
                <AreaTeks
                  baris={3}
                  value={s.prompt}
                  placeholder={t('bk.slidePrompt')}
                  onChange={(e) => ubah(i, 'prompt', e.target.value)}
                />
                {/* PENGHITUNG, BUKAN PEMOTONG. `maxLength` menghentikan ketikan
                    diam-diam tanpa mengatakan apa pun — operator melaporkannya sebagai
                    "input panjang selalu kepotong", dan batas yang memotong tanpa
                    memberi tahu memang terasa seperti kerusakan. Sekarang ia boleh
                    menempel teks panjang lalu merapikannya sendiri; yang di atas batas
                    ditolak saat dikirim, dengan sebabnya. */}
                <span className={cx(
                  'self-end text-[10.5px] tabular',
                  (s.prompt || '').length > MAKS_PROMPT ? 'text-bad' : 'text-ink3',
                )}>
                  {(s.prompt || '').length} / {MAKS_PROMPT}
                </span>
                <BarisBuat harga={s.biaya}>
                  <Tombol
                    kecil
                    disabled={!s.prompt.trim() || sedangBuat}
                    onClick={() => buatGambar(i, rasioKirim)}
                  >
                    {/* "Buat ulang" saat sudah ada gambarnya — kata yang berbeda, karena
                        akibatnya berbeda: yang lama hilang dan biayanya ditagih lagi. */}
                    {s.url ? t('bk.buatUlang')
                           : t(video ? 'bk.buatVideo' : 'bk.buatGambar')}
                  </Tombol>
                  {/* UNGGAH GAMBAR SENDIRI — jalan kedua, dan satu-satunya yang tidak
                      menagih apa pun. Foto produk, materi dari klien, dan desain yang
                      sudah jadi tidak perlu dibuat ulang model; sampai 14 September
                      tidak ada cara memasukkannya sama sekali. Video dikecualikan:
                      unggahan video menuntut watermark lewat ffmpeg, jalur yang belum
                      dibangun — tombol yang gagal separuh waktu lebih buruk daripada
                      tombol yang tidak ada. */}
                  {!video && unggahSlide && (
                    <label className="inline-flex">
                      <span className={GAYA_UNGGAH}>
                        {slideDiunggah === i ? t('umum.menunggu') : t('bk.unggahSendiri')}
                      </span>
                      <input
                        type="file" accept="image/png,image/jpeg,image/webp"
                        className="hidden" disabled={slideDiunggah !== null}
                        onChange={async (e) => {
                          const berkas = e.target.files?.[0]
                          // Direset supaya berkas YANG SAMA bisa dipilih lagi sesudah
                          // gagal — `change` tidak menyala kalau nilainya tidak berubah.
                          e.target.value = ''
                          if (!berkas) return
                          setSlideDiunggah(i)
                          setGalatSlide('')
                          try {
                            const r = await unggahSlide(berkas)
                            // `biaya` DIKOSONGKAN: gambar unggahan tidak menagih apa pun,
                            // dan membiarkan harga generasi sebelumnya menempel membuat
                            // perkiraan tagihan di layar ini berbohong.
                            // BENTUK FUNGSIONAL, bukan `slide` dari closure: ada
                            // `await` di atas, dan apa pun yang diketik orangnya
                            // selama unggahan berjalan akan hilang kalau larik lama
                            // yang dipetakan.
                            setSlide((x) => setelUnggah(x, i, r?.image_url || ''))
                          } catch (err) {
                            setGalatSlide(err?.message || 'Gagal mengunggah')
                          } finally {
                            setSlideDiunggah(null)
                          }
                        }}
                      />
                    </label>
                  )}
                </BarisBuat>

                {/* ── UBAH GAMBAR INI ────────────────────────────────────────
                    Terpisah dari "Buat ulang", karena akibatnya berbeda:
                    "Buat ulang" membuat gambar baru dari nol dan hasilnya bisa
                    sangat berbeda; "Ubah" berangkat dari gambar yang sedang
                    terpilih dan cuma menggeser satu hal.

                    Video dikecualikan: tidak satu pun model video di katalog
                    menerima video masukan. */}
                {!video && ubahGambar && s.url && (
                  <div className="mt-2 flex flex-col gap-1.5 border-t border-line pt-2">
                    <div className="flex flex-wrap items-end gap-2">
                      <AreaTeks
                        baris={2}
                        className="flex-1 min-w-[180px]"
                        value={instruksi[i] ?? ''}
                        placeholder={t('bk.ubahApa')}
                        onChange={(e) => setInstruksi((x) => ({ ...x, [i]: e.target.value }))}
                      />
                      <Tombol
                        kecil
                        disabled={!bisaUbah(s, instruksi[i]) || sedangUbah === i}
                        onClick={async () => {
                          setSedangUbah(i)
                          setGalatSlide('')
                          try {
                            await ubahGambar(i, (instruksi[i] || '').trim())
                            setInstruksi((x) => ({ ...x, [i]: '' }))
                          } catch (e) {
                            setGalatSlide(e?.message || String(e))
                          } finally {
                            setSedangUbah(null)
                          }
                        }}
                      >
                        {sedangUbah === i ? t('umum.menunggu') : t('bk.ubahGambar')}
                      </Tombol>
                    </div>
                    {/* Tiketnya hilang untuk gambar yang dimuat dari konten LAMA —
                        dibuat sebelum tiket ada. Dikatakan, bukan dibiarkan jadi
                        tombol mati yang tidak menyebut sebabnya. */}
                    <Sub>{t('bk.ubahKet')}</Sub>
                    {!s.tiket && <Sub>{t('bk.ubahTakBisa')}</Sub>}
                    {/* MUNCUL SEJAK HASIL PERTAMA, bukan sejak yang kedua.
                        Gate `> 1` yang lama menyembunyikannya persis pada saat orang
                        paling butuh tahu apa yang akan diubah — dan membuat bentuk
                        layarnya berubah begitu hasil kedua datang. Satu kotak yang
                        jelas terpilih lebih baik daripada tidak ada kotak sama
                        sekali; operator menanyakannya: "tidak bisa memilih yang mana
                        yang akan di edit? atau sudah otomatis?" */}
                    {(s.hasil ?? []).length > 0 && (
                      <>
                        <Sub>{t('bk.hasilDeret')}</Sub>
                        <div className="flex flex-wrap gap-1.5">
                          {(s.hasil ?? []).map((h, k) => (
                            <button
                              key={h.url}
                              type="button"
                              aria-pressed={h.url === s.url}
                              title={t('bk.hasilKe', { n: k + 1 })}
                              onClick={() => setSlide((x) => pilihHasil(x, i, h.url))}
                              className={cx(
                                'w-[44px] h-[44px] rounded border overflow-hidden p-0',
                                'cursor-pointer bg-surface',
                                h.url === s.url
                                  ? 'border-accent ring-1 ring-accent'
                                  : 'border-line hover:border-ink3',
                              )}
                            >
                              <Gambar src={h.url} className="w-full h-full object-cover"
                                      teksHilang={t('bk.gambarHilang')} />
                            </button>
                          ))}
                        </div>
                        <Sub>{t('bk.hasilKet')}</Sub>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        </Bagian>

        {galatSlide && (
          <Bendera nada="bad" role="alert">{galatSlide}</Bendera>
        )}

        {/* SATU VIDEO, BUKAN COLLASE. Instagram tidak punya collase video, dan tombol
            yang menambah slide kedua hanya menghasilkan konten yang ditolak saat terbit
            — jauh dari orang yang menekannya. */}
        {!video && (
        <div className="flex flex-wrap items-center gap-2">
          <Tombol
            kecil
            jenis="sekunder"
            disabled={slide.length >= MAKS_SLIDE}
            onClick={() => setSlide([...slide, { prompt: '', url: '', biaya: null }])}
          >
            {t('bk.tambahSlide')}
          </Tombol>
          <span className="text-[11.5px] text-ink3">
            {slide.length >= MAKS_SLIDE
              ? t('bk.slideMaks', { n: MAKS_SLIDE })
              : t('bk.slideRingkas', { jadi, total: slide.length })}
          </span>
        </div>
        )}

        {collase && <Bendera nada="warn">{t('bk.collaseBiaya', { n: slide.length })}</Bendera>}
        {galat && <Bendera nada="bad" role="alert">{galat}</Bendera>}
      </Body>
    </Panel>
  )
}
